function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscovery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 111.001,
    height: 101.01,
    viewBox: "0 0 111.001 101.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1523",
    transform: "translate(-934.5 -3921.491)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 3624",
    cx: 20.891,
    cy: 20.891,
    r: 20.891,
    transform: "translate(979.922 3955.28)",
    style: {
      stroke: "#7EEAFF",
      strokeMiterlimit: 10,
      strokeWidth: 3,
      fill: "rgba(41,230,211,.35)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17833",
    d: "M268.436 275.941A10.743 10.743 0 0 0 262.344 290",
    transform: "translate(725.957 3689.569)",
    style: {
      fill: "none",
      stroke: "#7EEAFF",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17834",
    d: "m321.172 340.975-18.666-18.666a9.888 9.888 0 0 0 8.654-8.654l18.666 18.666c2.623 2.623 2.812 6.687.422 9.076s-6.453 2.203-9.076-.422z",
    transform: "translate(712.077 3677.928)",
    style: {
      fill: "none",
      stroke: "#7EEAFF",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17835",
    d: "M197.411 256.066a45.153 45.153 0 0 1 16.664 7.7H174.09v-53.937h6.246v45.607a45.046 45.046 0 0 1 17.075.63z",
    transform: "translate(761.91 3718.236)",
    style: {
      fill: "none",
      stroke: "#7EEAFF",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17836",
    d: "M239.45 263.768h41.025v-53.939h-5.855v45.191a52.156 52.156 0 0 0-16.744.838c-1.536.33-3 .716-4.392 1.15a51.8 51.8 0 0 0-8.1 3.267",
    transform: "translate(736.548 3718.236)",
    style: {
      fill: "none",
      stroke: "#7EEAFF",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17837",
    d: "m218.149 235.422.257-24.887a46.343 46.343 0 0 0-34.106-8.5v49.975a44.877 44.877 0 0 1 33.592 8.3",
    transform: "translate(757.946 3721.451)",
    style: {
      fill: "none",
      stroke: "#7EEAFF",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17838",
    d: "M239.2 260.338a53.4 53.4 0 0 1 6.087-3.542 51.685 51.685 0 0 1 8.192-3.248c1.34-.4 2.747-.771 4.221-1.083a52.97 52.97 0 0 1 16.817-.838v-49.559a49.486 49.486 0 0 0-19.632 1.346 49.457 49.457 0 0 0-15.166 7.158q-.128 12.443-.263 24.887l-.269 23.987",
    transform: "translate(736.648 3721.416)",
    style: {
      fill: "none",
      stroke: "#7EEAFF",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscovery);
export default __webpack_public_path__ + "static/media/discovery.039c859341cf0a1e2fbf9067a2483283.svg";
export { ForwardRef as ReactComponent };